import { UserAccess } from '#server/models';
import { Input } from '@/components/ui';
import { ChangeEvent, useEffect, useState } from 'react';
import { Link } from 'react-router';
const toSentenceCase = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
export interface UserAccessDetailsProps {
  userAccessDetails: UserAccess[];
  openAddUserSheet: (userId: string) => void;
}
export const UserAccessDetails = ({ userAccessDetails, openAddUserSheet }: UserAccessDetailsProps) => {
  const [searchIdName, setSearchIdName] = useState('');
  const [searchSchool, setSearchSchool] = useState('');
  const [groupedData, setGroupedData] = useState<Record<string, typeof userAccessDetails>>({});
  const handleSearchByIdName = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchIdName(event.target.value);
  };
  const handleSearchBySchool = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchSchool(event.target.value);
  };

  useEffect(() => {
    const filteredData = userAccessDetails.filter(
      (userAccess) =>
        (userAccess.curtinId.toLowerCase().includes(searchIdName.toLowerCase()) ||
          userAccess.firstName.toLowerCase().includes(searchIdName.toLowerCase()) ||
          userAccess.lastName.toLowerCase().includes(searchIdName.toLowerCase())) &&
        userAccess.schoolName.toLowerCase().includes(searchSchool.toLowerCase()),
    );
    const filteredGroups = filteredData.reduce(
      (acc, curr) => {
        if (!curr) {
          return acc;
        }
        if (!acc[curr.curtinId]) {
          acc[curr.curtinId] = [];
        }
        acc[curr.curtinId]?.push(curr);
        return acc;
      },
      {} as Record<string, typeof userAccessDetails>,
    );
    const sortedFilteredGroups: Record<string, UserAccess[]> = Object.fromEntries(
      Object.entries(filteredGroups).map(([curtinId, users]) => [
        curtinId,
        [...users].sort((a, b) => a.schoolName.localeCompare(b.schoolName)),
      ]),
    );
    setGroupedData(sortedFilteredGroups);
  }, [searchIdName, searchSchool, userAccessDetails]);

  return (
    <div>
      <div className="flex w-auto gap-10">
        <Input
          type="text"
          className="my-4 w-[260px] border-secondary-grey-04 pr-10 text-b2"
          onChange={handleSearchByIdName}
          placeholder="Search by Curtin ID or name"
        />
        <Input
          type="text"
          className="my-4 w-[260px] border-secondary-grey-04 pr-10 text-b2"
          onChange={handleSearchBySchool}
          placeholder="Search by school name"
        />
      </div>
      <table className="min-w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-4 py-2 text-left">Curtin ID</th>
            <th className="border px-4 py-2 text-left">Name</th>
            <th className="border px-4 py-2 text-left">School</th>
            <th className="border px-4 py-2 text-left">Access level</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(groupedData).map(([curtinId, users]) =>
            users.map((user, index) => (
              <tr key={`${curtinId}-${index}`} className="border-t">
                {index === 0 && (
                  <>
                    <td className="border-2 px-4 py-2" rowSpan={users.length}>
                      <Link
                        to="#"
                        className="font-semibold text-deep-blue underline"
                        onClick={() => openAddUserSheet(curtinId)}
                      >
                        {curtinId}
                      </Link>
                    </td>
                    <td className="border-2 px-4 py-2" rowSpan={users.length}>
                      {user.lastName}
                      {user.firstName ? `, ${user.firstName}` : ''}
                    </td>
                  </>
                )}
                <td className="border-2 px-4 py-2">{user.schoolName}</td>
                <td className="border-2 px-4 py-2">{user.accessLevel}</td>
              </tr>
            )),
          )}
        </tbody>
      </table>
    </div>
  );
};
